// NOTE snake_case used to avoid aliasing a method named in backend code
import { SleepDiaryPayloads } from '@bighealth/types/src/services/SleepDiaryPayloads';
import { DiaryEntry } from '@bighealth/types/src/services/SleepDiaryPayloads/types';

/**
 *
 * @param {DiaryEntry} args
 */
const update_single_day_entry_with_date = (
  args: DiaryEntry
): SleepDiaryPayloads['update_single_day_entry_with_date']['request'] => {
  return {
    service_name: 'SleepDiary',
    service_version: '1',
    service_method: 'update_single_day_entry_with_date',
    args,
  };
};

export { update_single_day_entry_with_date };
